import Breadcrumb from "../../SharedComponents/components/Breadcrumb/Breadcrumb";
import BuyerLayout from "../components/Layout";
import MessagesInActiveRequestsTable from "../components/Tables/Table/MessagesInActiveRequestsTable";
import MessagesInOtherRequestsTable from "../components/Tables/Table/MessagesInOtherRequestsTable";

const Messages = () => {
    const breadcrumbs = [
        { title: "Početak", href: "/home" },
        { title: "Poruke" }
    ];

    return (
        <BuyerLayout>
            <Breadcrumb
                title={"Poruke"}
                breadcrumbs={breadcrumbs}
            />

            <div style={styles.containerMarginTop}>
                <MessagesInActiveRequestsTable />
            </div>


            <div style={styles.containerMarginTop}>
                <MessagesInOtherRequestsTable />
            </div>

        </BuyerLayout>
    );
};

export default Messages;

const styles = {
    containerMarginTop: {
        marginTop: 20,
    },
};
